import Config from 'Config';
import axios from 'axios';

const getAllUsersApiCall = async () => {
  const url = `${Config.hostName}/client/getUserDetails`;
  const requestBody = {
    clientId: ''
  };
  const userData = localStorage.getItem('userData');

  const token = JSON.parse(userData).token;

  const response = await axios.post(url, requestBody, {
    headers: {
      'x-access-token': token
    }
  });
  const data = response.data;
  return data;
};

export const getAllUsersApi = async () => {
  const data = await getAllUsersApiCall();
  return data;
};

const getClientsDropDownApiCall = async () => {
  const url = `${Config.hostName}/client/getClientsDropDown`;

  const userData = localStorage.getItem('userData');
  const requestBody = {
    ptlUserId: JSON.parse(userData).PTLUserid
  }
  const token = JSON.parse(userData).token;
  console.log(token);
  const response = await axios.post(url, requestBody, {
    headers: {
      'x-access-token': token
    }
  });
  const data = response.data;
  return data;
};

export const getClientsDropDownApi = async () => {
  const data = await getClientsDropDownApiCall();
  return data;
};

const saveUserIpApiCall = async (requestBody) => {
  const url = `${Config.hostName}/client/captureDashboardUserActivity`;

  const userData = localStorage.getItem('userData');

  const token = JSON.parse(userData).token;

  const response = await axios.post(url, requestBody, {
    headers: {
      'x-access-token': token
    }
  });
  const data = response.data;
  return data;
};

export const saveUserIpApi = async (requestBody) => {
  const data = await saveUserIpApiCall(requestBody);
  return data;
};

const getBillableAmountApiCall = async (requestBody) => {
  console.log(requestBody);
  const url = `${Config.hostName}/client/getBillableAmount`;
  const userData = localStorage.getItem('userData');
  const token = JSON.parse(userData).token;
  const response = await axios.post(url, requestBody, {
    headers: {
      'x-access-token': token
    }
  });
  const data = response.data;
  return data;
};

export const getBillableAmountApi = async (requestBody) => {
  // console.log('API CALL', requestBody)
  const data = await getBillableAmountApiCall(requestBody);
  return data;
};

const getHubCodesDropDownApiCall = async (requestBody) => {
  const url = `${Config.hostName}/client/getSourceCodesDropDownByLocationAndClient`;
  const userData = localStorage.getItem('userData');
  // console.log(userData);
  const token = JSON.parse(userData).token;
  // console.log(token);
  const response = await axios.post(url, requestBody, {
    headers: {
      'x-access-token': token
    }
  });
  const data = response.data;
  return data;
};

export const getHubCodesDropDownApi = async (requestBody) => {
  // console.log('API CALL')
  const data = await getHubCodesDropDownApiCall(requestBody);
  return data;
};
